import { createContext } from 'react';

export type UserControlLockTarget = 'page' | 'drawer';

export interface UserControlSettings {
  locked: boolean;
  toggleLocked: (locked: boolean, target?: UserControlLockTarget) => void;
  checkLockedAndEmit: (target?: UserControlLockTarget) => boolean;
}

export const UserControlContext = createContext<UserControlSettings>({
  locked: false,
  toggleLocked: () => null,
  checkLockedAndEmit: () => false,
});
